import {
  SET_SAVE_PROGRESS_ACTION,
  SET_INITIAL_SAVE_PROGRESS_ACTION,
  RESET_SAVE_PROGRESS_ACTION,
  SET_SAVE_DIALOG_FILENAME_ACTION,
  READ_DOCUMENT_PROPERTIES_ACTION,
  SET_DOCUMENT_DATA_ACTION,
  SET_TEMPLATE_RUN_REPORT_ACTION,
  DISMISS_TEMPLATE_RUN_REPORT_ACTION
} from './actions'
import {
  TEMPLATES_SET_SELECTED_FILE_ACTION
} from '../templates/actions'

const SAVE_DATA_DEFAULT = {
  documentData: {
    contact: {}, // Result from API call /contact
    project: {}, // Result from API call /project
    selectedPersonRole: {}, // The selected person based on project.person_role or contact.person_role
    me: {} // The logged in user
  },
  loaded: {
    contact: false,
    project: false
  },
  saveProgress: {
    folders: { saved: 0, total: 0 },
    files: { saved: 0, total: 0 },
    templates: { saved: 0, total: 0 },
    inProgress: false
  },
  fileName: '',
  templateRun: null
}

/**
 * Reducer for the save dialog
 */
export function save (state = SAVE_DATA_DEFAULT, action) { // eslint-disable-line
  switch (action.type) {
    case SET_TEMPLATE_RUN_REPORT_ACTION:
      return { ...state, templateRun: action.report }
    case DISMISS_TEMPLATE_RUN_REPORT_ACTION:
      return state.templateRun?.running ? state : { ...state, templateRun: null }
    case SET_SAVE_PROGRESS_ACTION: {
      const { progressType, progress } = action
      const { saveProgress } = state

      const updatedSaveProgress = Object.assign({}, saveProgress, {
        [progressType]: progress,
        inProgress: true
      })
      return Object.assign({}, state, { saveProgress: updatedSaveProgress })
    }
    case SET_INITIAL_SAVE_PROGRESS_ACTION: {
      const { total } = action
      const { saveProgress } = state
      const updatedSaveProgress = Object.assign({}, saveProgress, {
        folders: { saved: 0, total: total.folders },
        files: { saved: 0, total: total.files },
        templates: { saved: 0, total: total.templates },
        inProgress: true
      })
      return Object.assign({}, state, { saveProgress: updatedSaveProgress })
    }
    case RESET_SAVE_PROGRESS_ACTION: {
      const { saveProgress } = state
      const updatedSaveProgress = Object.assign({}, saveProgress, {
        folders: { saved: 0, total: 0 },
        files: { saved: 0, total: 0 },
        templates: { saved: 0, total: 0 },
        inProgress: false
      })
      return Object.assign({}, state, { saveProgress: updatedSaveProgress })
    }
    case SET_SAVE_DIALOG_FILENAME_ACTION: {
      const { fileName } = action
      return Object.assign({}, state, { fileName })
    }
    case TEMPLATES_SET_SELECTED_FILE_ACTION: {
      const { file } = action
      return Object.assign({}, state, { fileName: file.name })
    }
    case READ_DOCUMENT_PROPERTIES_ACTION: {
      const incomingDocumentData = action.documentData || action.documentProperties || {}
      const updatedDocumentData = Object.assign({}, state.documentData, incomingDocumentData)
      return Object.assign({}, state, { documentData: updatedDocumentData })
    }
    case SET_DOCUMENT_DATA_ACTION: {
      const { key, value } = action
      const { documentData } = state
      const updatedDocumentData = Object.assign({}, documentData, {
        [key]: value
      })
      const updatedLoaded = Object.assign({}, state.loaded, {
        [key]: true
      })
      return Object.assign({}, state, { documentData: updatedDocumentData, loaded: updatedLoaded })
    }
    default:
      return state
  }
}
